import React, { useState, FC, ChangeEvent } from 'react';
import styles from './multiselect.module.scss';
import { Subdivision } from '../../../types/subdivision';
import { ReactComponent as BlueCross } from '../../../assets/images/Cross.svg';
import { ReactComponent as GrayCross } from '../../../assets/images/multiselectCross.svg';
import { ReactComponent as Arrow } from '../../../assets/images/multiselectArrow.svg';

interface MultiselectProps {
  subdivisions: Array<Subdivision>;
  defaultSelectedSubdivisions?: Array<Subdivision>;
  disabled: boolean;
  onSelect: (subdivisions: Array<Subdivision>) => void;
}

export const Multiselect: FC<MultiselectProps> = ({
  subdivisions,
  defaultSelectedSubdivisions,
  disabled,
  onSelect,
}) => {
  const [selectedSubdivisions, setSelectedSubdivisions] = useState<
    Subdivision[]
  >(defaultSelectedSubdivisions ?? []);
  const [subdivisionsCopy, setSubdivisionsCopy] = useState<Subdivision[]>(
    subdivisions,
  );

  const select = (subdivision: Subdivision) => {
    setSelectedSubdivisions((prevSelectedSubdivisions) =>
      prevSelectedSubdivisions.concat([subdivision]),
    );
    onSelect(selectedSubdivisions);

    setSubdivisionsCopy((prevSubdivisionsCopy) =>
      prevSubdivisionsCopy.filter((item) => item.id !== subdivision.id),
    );
  };

  const unselect = (subdivision: Subdivision) => {
    setSelectedSubdivisions((prevSelectedSubdivisions) =>
      prevSelectedSubdivisions.filter((item) => item.id !== subdivision.id),
    );
    onSelect(selectedSubdivisions);

    setSubdivisionsCopy((prevSubdivisionsCopy) =>
      prevSubdivisionsCopy.concat([subdivision]),
    );
  };

  const clearSelected = () => {
    setSelectedSubdivisions([]);
    onSelect(selectedSubdivisions);
    setSubdivisionsCopy(subdivisions);
  };

  const filterSubdivisions = (e: ChangeEvent<HTMLInputElement>) => {
    const filteredSubdivisions = subdivisions.filter((subdivision) =>
      subdivision.subDivisionName.includes(e.target.value),
    );
    setSubdivisionsCopy(filteredSubdivisions);
  };

  return (
    <div className={disabled ? styles.disabledField : styles.select}>
      <label className={styles.select__label} htmlFor="field">
        <div className={styles.output}>
          {selectedSubdivisions.map((subdivision) => (
            <div key={subdivision.id} className={styles.output__subdivision}>
              {subdivision.subDivisionName}
              <BlueCross onClick={() => unselect(subdivision)} />
            </div>
          ))}
          <input
            id="field"
            type="text"
            placeholder={!selectedSubdivisions.length ? 'Подразделение' : ''}
            className={styles.select__input}
            onChange={filterSubdivisions}
          />
          <div className={styles.output__controls}>
            <GrayCross
              className={!selectedSubdivisions.length ? styles.hidden : ''}
              onClick={clearSelected}
            />
            <Arrow className={disabled ? styles.disabledArrow : styles.arrow} />
          </div>
        </div>
        <div className={styles.subdivisionsList}>
          {subdivisionsCopy.length ? (
            subdivisionsCopy.map((subdivision) => (
              <div
                key={subdivision.id}
                className={styles.subdivisionsList__item}
                onClick={() => select(subdivision)}
              >
                {subdivision.subDivisionName}
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>Результатов не найдено</p>
          )}
        </div>
      </label>
    </div>
  );
};
